import React, { useState } from "react";
import "./Login.css";
import AuthService from "../services/AuthService";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pending) return;
    setPending(true);
    try {
      await AuthService.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      toast.error(err?.message || "Request failed.");
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-shell">
        <div className="auth-card">
          <h2 className="auth-title">Reset your password</h2>
          {sent ? (
            <p className="auth-text">
              If an account exists for that email, a reset link has been sent. Check your inbox.
            </p>
          ) : (
            <>
              <p className="auth-text">Enter your email and we'll send a reset link.</p>
              <form onSubmit={submit}>
                <input className="auth-input" type="email" placeholder="Email"
                  value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
                <button type="submit" className="auth-btn auth-btnPrimary" disabled={pending}>
                  {pending ? "Sending…" : "Send reset link"}
                </button>
              </form>
            </>
          )}
          <div className="auth-links">
            <Link to="/login">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
